import { sylvanus } from '~/services/serviceInstances';

export const interruptAgentExecution = async (
  agentExecutionId: string,
): Promise<void> => {
  return sylvanus.post(`/agent-execution/${agentExecutionId}/interrupt`);
};
